<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12">
                <h1>Reports</h1>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Registration Reports</strong>
                    </div>
                    <div class="form-container">
                        <b-row>
                            <b-col cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-pie-chart p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">Quick Plate Report</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">Monthly Registration number report for all plates </div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/reports/plateReport'">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-download p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">6 - 12 Month Plate Report</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">6 - 12 Month Registration number report for all plates </div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/reports/dataExport'">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col v-if="canShowPlatesPerDayReport" cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-bar-chart p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">Plates Count Per Day</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">Report for amount of plates printed per day </div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/reports/plates-count-per-day'">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col v-if="canShowReprintReasonReport" cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-commenting p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">Reprint Reason Report</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">Report for plates printed with a given repeat reason </div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/reports/repeat-reason-report'">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col v-if="canShowLatestPrintsReport" cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-filter p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">Latest Prints Report</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">The latest plate prints for all sites </div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/reports/latestPrintsReport'">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col v-if="canShowSiteDesktopVersionReport" cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-filter p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">Site Desktop Versions</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">Lists all sites with their current dekstop app version </div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/reports/sitesAppVersionReport'">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col v-if="canShowUsersReportsReport" cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-user p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">Users Report</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">Lists all users on the system </div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/reports/usersreport'">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
  name: 'reportsDashboard',
  components: {
  },
  data () {
    return {
        canShowLatestPrintsReport: false,
        canShowLatestPrintsReport: false,
        canShowLatestPrintsReport: false,
        canShowPlatesPerDayReport: false,
        canShowReprintReasonReport: false,
        canShowSiteDesktopVersionReport: false,
        canShowUsersReportsReport: false,
        userObj: {},
    }
  },
  created () {
      this.getUser();
  },
  methods : {
    getUser() {
      return new Promise((resolve, reject) => {
        this.$data.userObj = JSON.parse(localStorage.getItem('user'));
        if (this.$data.userObj.authcode === undefined) {
          this.$router.push('/pages/login');
        }
        if (this.$data.userObj.auth == "Company Users") {
          this.$data.canShowLatestPrintsReport = false;
          this.$data.canShowLatestPrintsReport = false;
          this.$data.canShowPlatesPerDayReport = false;
          this.$data.canShowReprintReasonReport = false;
          this.$data.canShowSiteDesktopVersionReport = false;
          this.$data.canShowUsersReportsReport = false;
        }
        else {
          this.$data.canShowLatestPrintsReport = false;
          this.$data.canShowLatestPrintsReport = false;
          this.$data.canShowPlatesPerDayReport = false;
          this.$data.canShowReprintReasonReport = false;
          this.$data.canShowSiteDesktopVersionReport = false;
          this.$data.canShowUsersReportsReport = false;
        }
        if (this.$data.userObj.auth == "Super Admin") {
          this.$data.canShowLatestPrintsReport = true;
          this.$data.canShowPlatesPerDayReport = true;
          this.$data.canShowReprintReasonReport = true;
          this.$data.canShowSiteDesktopVersionReport = true;
          this.$data.canShowUsersReportsReport = true;
        }
        else {
          this.$data.canShowLatestPrintsReport = false;
          this.$data.canShowLatestPrintsReport = false;
          this.$data.canShowPlatesPerDayReport = false;
          this.$data.canShowReprintReasonReport = false;
          this.$data.canShowSiteDesktopVersionReport = false;
          this.$data.canShowUsersReportsReport = false;
        }
        resolve();
      });
    },
  }
}
</script>
